import React, { useContext, useEffect, useState } from "react";
import "./SubscriptionsLink.scss";
import { Context } from "../../Store";
import { Link } from "react-router-dom";

import vector5 from "../../../imgs/vector5.png";
const SubscriptionsLink = () => {
  let { dir, setIsClicked, packagesResData, packagesSection, translate } =
    useContext(Context);
  let { title, subTitle } = translate.home.packages;

  // let { title, subTitle } = packagesResData;

  useEffect(() => {
    setIsClicked(false);
  }, [setIsClicked]);
  return (
    <section id="subscriptions-link" ref={packagesSection}>
      <img
        src={vector5}
        className={dir === "ltr" ? "vector5L" : "vector5R"}
        alt=""
      />
      <div className="container">
        <h2>{dir === "ltr" ? title[0] : title[1]}</h2>
        <p>{dir === "ltr" ? subTitle[0] : subTitle[1]}</p>
        <Link to="subscriptions">
          <button> {dir === "ltr" ? "Discover More" : "اكتشف المزيد"}</button>
        </Link>
      </div>
    </section>
  );
};

export default SubscriptionsLink;
